import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import useIsMounted from '@/layout/components/hooks/useIsMounted';
import { axiosPath } from '@/routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import BreadcrumbHandler from '@/layout/components/breadcrumb/BreadcrumbHandler';
import AppLink from '@/routing/helpers/AppLink';
import DevelopmentCard from '@/layout/screenSpecifics/Modules/DynamicForm/DevelopmentCard';
import ModalWarning from '@/layout/screenSpecifics/Modules/DynamicForm/ModalWarning';
import * as currentPageAction from '@/store/actions/currentPageAction';
import { AppCard, AppNoInfo, AppRemixIcon } from '@/layout/AppComponents';
// import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
// import useIsMounted from '../../../layout/components/hooks/useIsMounted';
// import { errorHandler } from '../../../layout/components/error/errorHandlerNew';
// import { axiosPath } from '../../../routing/helpers/router';
// import Translator from '../../../layout/components/helpers/Translator';
// import AppLink from '../../../routing/helpers/AppLink';
// import DevelopmentCard from '../../../layout/screenSpecifics/Modules/DynamicForm/DevelopmentCard';
// import ModalWarning from '../../../layout/screenSpecifics/Modules/DynamicForm/ModalWarning';

export default function ModuleDynamicFormEndScreen() {
  const { moduleBridgeHex, dynamicFormUserFormID } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData
  );
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState();
  const [modalWarning, setModalWarning] = useState();

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  // > LOAD FORM DATA
  const loadFormData = useCallback(
    async () =>
      axios
        .post(axiosPath('api_r_user_module_dynamicForm_end'), {
          moduleBridgeHex,
          dynamicFormUserFormID,
        })
        .then((r) => {
          if (isMounted.current) {
            if (r.status === 203) {
              setModalWarning(r?.data);
              return;
            }
            setFormData(r?.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e)))
        .finally(() => setLoading(false)),
    [moduleBridgeHex, dynamicFormUserFormID]
  );

  useEffect(() => {
    loadFormData();
  }, []);
  // < LOAD FORM DATA

  const print = useCallback(() => {
    const newWin = window.open('', 'Print');

    newWin.document.open();
    newWin.document.write(
      '<html><body onload="window.print()">' +
        formData?.report +
        '</body></html>'
    );

    newWin.document.close();
  }, [formData]);

  return (
    <>
      <BreadcrumbHandler
        paths={
          moduleData
            ? [
                {
                  name: moduleData?.moduleName,
                  route: {
                    name: 'user_module_dynamicForm_home',
                    params: {
                      moduleBridgeHex,
                    },
                  },
                },
              ]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4 mb-5">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          {loading ? (
            <AppNoInfo minHeight={window.innerHeight - 60} />
          ) : (
            <>
              {formData && (
                <>
                  <AppCard>
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <button
                            type="button"
                            className="btn btn-danger btn-xs float-right"
                            onClick={print}
                          >
                            <AppRemixIcon icon="file-pdf-2" />
                          </button>
                        </div>
                        <div className="col-lg-12">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: formData?.report,
                            }}
                          />
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12 d-flex">
                          <AppLink
                            path="user_module_dynamicForm_home"
                            params={{
                              moduleBridgeHex,
                            }}
                            className="btn btn-light"
                            style={{ marginLeft: 'auto' }}
                          >
                            <AppRemixIcon
                              icon="corner-down-left"
                              className="mr-2"
                            />
                            Volver al inicio
                          </AppLink>
                        </div>
                      </div>
                    </div>
                  </AppCard>
                  <DevelopmentCard pvGlobalData={formData?.pvGlobalData} />
                </>
              )}
            </>
          )}
        </div>
      </main>
      <DevelopmentCard pvGlobalData={formData?.pvGlobalData} />
      <ModalWarning modalWarning={modalWarning} />
    </>
  );
}
